export { default } from "./useShowProductsSection";
